import React, { useState } from 'react'
import './TracerCard.css'
import TracerApi from '../Api/Tracercarapi';
import TracerApi2 from '../Api/TracerApi2';
import TracerApi3 from '../Api/TracerApi3';
import TracerProgress from '../../Component/Sidebar/TracerProgress';
const TracerCard = () => {
  const [card , setCard] = useState(TracerApi);
  const[card2, setCard2]=  useState(TracerApi2);
  const [card3, setCard3] = useState(TracerApi3);
  return (
    <div>
      <div className="card-info">
      <div className="card-detail">
                <div className="card-detail-info">
                  <div className="card-count">
                  755470
                  </div>
                 <div className="bar-card">
                   <TracerProgress done={80}/>
                 </div>
                  <div className="info-point">
                    <div className="info">
                    Stag 2:00.41
                    </div>
                  <div className="card-point">
                    <div className="left-point">
                    B12
                    </div>
                    <div className="right-point">
                    12
                    </div>
                  </div>
                  </div>
                </div>
              </div>
        {
          TracerApi3.map((Elmnt)=>{
            const {id, count, info, leftPoint, rightPoint} = Elmnt;
            return(
              <>
              <div className="card-detail">
                <div className="card-detail-info">
                  <div className="card-count">
                    {count}
                  </div>
                  <div className="info-point">
                    <div className="info">
                      {info}
                    </div>
                  <div className="card-point">
                    <div className="left-point">
                      {leftPoint}
                    </div>
                    <div className="right-point">
                      {rightPoint}
                    </div>
                  </div>
                  </div>
                </div>
              </div>
              </>
            )
          })
        }
      </div>
      <div className="card-info">
      <div className="card-detail">
                <div className="card-detail-info">
                  <div className="card-count">
                   ######
                  </div>
                  <div className="info-point">
                    <div className="info info-code">
                    super(props); <br />
    this.state &#x3D; <br />
    &#123;hasror	&#58; flse &#125;;
                    </div>
                
                  </div>
                </div>
              </div>
        {
          TracerApi2.map((Elmnt)=>{
            const {id, count, info, leftPoint, rightPoint} = Elmnt;
            return(
              <>
              <div className="card-detail" >
                <div className="card-detail-info">
                  <div className="card-count">
                    {count}
                  </div>
                  <div className="info-point">
                    <div className="info">
                      {info}
                    </div>
                  <div className="card-point">
                    <div className="left-point">
                      {leftPoint}
                    </div>
                    <div className="right-point">
                      {rightPoint}
                    </div>
                  </div>
                  </div>
                </div>
              </div>
              </>
            )
          })
        }
      </div>
      <div className="card-info">
        {
          TracerApi.map((Elmnt)=>{
            const {id, count, info, leftPoint, rightPoint} = Elmnt;
            return(
              <>
              <div className="card-detail">
                <div className="card-detail-info">
                  <div className="card-count">
                    {count}
                  </div>
                  <div className="info-point">
                    <div className="info">
                      {info}
                    </div>
                  <div className="card-point">
                    <div className="left-point">
                      {leftPoint}
                    </div>
                    <div className="right-point">
                      {rightPoint}
                    </div>
                  </div>
                  </div>
                </div>
              </div>
              </>
            )
          })
        }
      </div>
      
    </div>
  )
}

export default TracerCard;